import ContentLoader from 'react-content-loader'
import React from 'react'

const GenericCardPlaceholder = React.memo(props => (
  <ContentLoader
    speed={2}
    width={216}
    height={338}
    viewBox="0 0 216 338"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="0" rx="16" ry="16" width="216" height="338" />
  </ContentLoader>
))

export default GenericCardPlaceholder
